import { useState, useEffect, useContext } from "react";
import { Row, Col, Spinner, Breadcrumb } from "reactstrap";
import styles from './MyProducts.module.scss';
import Breadcrumbs from "../../../global/Components/Breadcrumb/Breadcrumb";
import ProductCard from "../../../global/Components/Items/ProductCard/ProductCard";
import useAuth from "../../../global/utils/hooks/useAuth";
import PaginationComponent from "../../../global/Components/Pagination/PaginationComponent";
// import { useSearchParams } from "react-router-dom";
import useApiPrivate from "../../../global/utils/hooks/useApiPrivate";
import { UserContext } from "../../../global/globalContext/context";
import { showMsg } from "../../../global/langs/langs";

const PRODUCTS_URL = 'api/v1/products';

export default function MyProducts() {
  const apiPrivate = useApiPrivate();
  // const[searchParams, setSearchParams] = useSearchParams();
  const {lang} = useContext(UserContext);
  
  const [isLoading, setIsLoading] = useState(false);
  
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState();
  const [currentPage, setCurrentPage] = useState();

  const callProducts = async () => {
    setIsLoading(true);

    try {
      const response = await apiPrivate.get(PRODUCTS_URL,{
        params: {
          seller: 1,
          page: currentPage && currentPage,
        }
      });
      setProducts(response.data.data);
      setMetaData(response.data.meta);
      setCurrentPage(response.data.meta?.current_page);
      setIsLoading(false);
    }
    catch (error) {
      setIsLoading(false);
    }
    finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    callProducts();
  },[]);

  useEffect(() => {
    callProducts();
    // currentPage &&
    //   searchParams.set('page', currentPage);
    //   setSearchParams(searchParams);
  },[currentPage]);

  return (
    <div>
      <Row>
        <Col sm={8} md={8}>
          <Breadcrumbs />
        </Col>
        <Col sm={4} md={4}>
          <div className={`text-end fsSmall`}>
            {
            metaData ? (
              <>
                {metaData.total}
                <span>
                  {' '}{showMsg('results', lang)}
                </span>
              </>
            ) : (
              <span>
                {showMsg('no_results', lang)}
              </span>
            )
            }
          </div>
        </Col>
      </Row>
      {
        isLoading 
          ? (
            <>
              <Spinner color='primary' className='mx-auto'>
                Loading...
              </Spinner>
            </>
          ) 
          : (
            products.length > 0
              ? (
                <>
                  <Row>
                  { 
                    products.map((product) => (
                      <Col key={product.id} xs={12} sm={6} md={6} xxl={6}>
                        <ProductCard data={product} callProducts={callProducts} />
                      </Col>                 
                    ))
                  }
                  </Row>
                </>
              ) 
              : (
                <p className="fw-bold py-4">
                  {showMsg('no_products_to_display', lang)}
                </p>
              )
          )
      }
      {
        metaData &&
          metaData.last_page > 1 
            ? (
              <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage}  metaData={metaData}/>
            ) 
            : ('')
      }       
    </div>
  )
}
